/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {LINKWASS, SECCIONES} from "../../Constantes";
import {WhatsApp} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {theme} from "../../Tema";
import {irUrl} from "../../Utilidades/irUrl";
import {useLocation, useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";

const BarraPc = ({esAzul}) => {
    const navigate = useNavigate();
    const {sCell} = useResponsive()
    const {ir} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: esAzul ? theme.palette.primary.main : '#ffffff00',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 1.5, pb: 2}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 11}}
                >

                    <Grid container size={{xs: 4, sm: 12, md: 5}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <img src={logo} width={250} height={'auto'} onClick={() => navigate('/Home')}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-end', mt: -1.5}}>
                        <Grid
                            container
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            {SECCIONES.map((item, index) => (
                                <Typography
                                    onClick={() => ir(item)}
                                    sx={{
                                        mt: 0.7,
                                        color: '#fff',
                                        borderBottom: 2,
                                        borderColor: "#00000000",
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        transition: 'all .2s ease-in-out',
                                        fontSize: 15,
                                        "&:hover": {
                                            borderColor: theme.palette.secondary.main,
                                        }
                                    }}
                                >{item}</Typography>
                            ))}

                            <Button
                                onClick={() => irUrl(LINKWASS)}
                                startIcon={<WhatsApp/>}
                                // sx={{px: 0}}
                                color={'secondary'}

                            >
                                Contactanos
                            </Button>

                        </Grid>
                    </Grid>


                </Grid>


            </Grid>


        </Grid>
    )

}
export default BarraPc    